//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {declOfNum, getArrForTitle, getContentByCode} from "@/utils/utils";

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    view: {
      type: String,
      required: false,
      default: 'v'
    },
    hasLink: {
      type: Boolean,
      default: true
    },
    sectionCode: {
      type: String,
      required: true
    },
  },
  inject: ['$isMobile'],
  computed: {
    isMobile() {
      return this.$isMobile()
    }
  },
  methods: {
    pictureUrl (url) {
      return this.$absoluteImageUrl(url)
    },
    getTextArr(text) {
      return getArrForTitle(text)
    },
    getText(code) {
      return getContentByCode(this.getTextBlocks.data.data, code)
    },
    getDeclination(num, key){
      if (this.$i18n.locale === 'en') {
        return this.$tc(key, num > 1 ? 2 : 1)
      } else {
        return this.$tc(key, declOfNum(num));
      }
    },
  }
}
